export default __webpack_public_path__ + "static/media/221111_notice02_221006.2c3107fd.pdf";